import { render, staticRenderFns } from "./CardDashboard.vue?vue&type=template&id=0dfd65aa&scoped=true&"
import script from "./CardDashboard.vue?vue&type=script&lang=js&"
export * from "./CardDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CardDashboard.vue?vue&type=style&index=0&id=0dfd65aa&lang=scss&scoped=true&"
import style1 from "./CardDashboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfd65aa",
  null
  
)

export default component.exports